module.exports = __webpack_public_path__ + "img/icon11.74311c12.png";